<div class="mis-solicitudes">
    <app-page-header icon="description" title="Mis Solicitudes" subtitle="Consulte el progreso de sus solicitudes realizadas"></app-page-header>

    <div class="mis-solicitudes__inner">
        <!-- ============ Toolbar ============ -->
        <div class="mis-solicitudes__toolbar">
            <p class="mis-solicitudes__count" *ngIf="flagLoaded">
                Encontramos <strong>{{ elementosFiltrados.length }}</strong> solicitudes
            </p>
            <p class="mis-solicitudes__count" *ngIf="!flagLoaded">
                Cargando solicitudes...
            </p>

            <div class="mis-solicitudes__buscador">
                <span class="material-icons">search</span>
                <input
                    type="text"
                    (keyup)="aplicarFiltro($event)"
                    placeholder="Buscar solicitud..."
                    aria-label="Buscar solicitud"
                />
            </div>
        </div>

        <!-- ============ Skeleton ============ -->
        <div class="ds-card mis-solicitudes__card" *ngIf="!flagLoaded">
            <div class="mis-solicitudes__skeleton" *ngFor="let r of skeletonRows">
                <span class="ds-skeleton mis-solicitudes__sk-sm"></span>
                <span class="ds-skeleton mis-solicitudes__sk-lg"></span>
                <span class="ds-skeleton mis-solicitudes__sk-md"></span>
                <span class="ds-skeleton mis-solicitudes__sk-sm"></span>
            </div>
        </div>

        <ng-container *ngIf="flagLoaded">
            <!-- ============ Vacío ============ -->
            <div class="ds-card mis-solicitudes__vacio" *ngIf="elementosPagina.length === 0">
                <span class="material-icons">inbox</span>
                <p>No encontramos solicitudes.</p>
            </div>

            <ng-container *ngIf="elementosPagina.length > 0">
                <!-- ============ Tabla (desktop) ============ -->
                <div class="ds-card mis-solicitudes__card mis-solicitudes__tabla">
                    <div class="mis-solicitudes__scroll">
                        <table class="ds-table">
                            <thead>
                                <tr>
                                    <th>Nro.</th>
                                    <th>Trámite</th>
                                    <th>Fecha</th>
                                    <th>Beneficiario</th>
                                    <th>Parentesco</th>
                                    <th>Estado</th>
                                    <th class="mis-solicitudes__th-acc">Acciones</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr *ngFor="let element of elementosPagina; trackBy: trackByElemento">
                                    <td class="mis-solicitudes__nro">{{ element._nro }}</td>
                                    <td>{{ element.tramite }}</td>
                                    <td class="mis-solicitudes__fecha">
                                        {{ element.fecha | date: "dd/MM/yy" }}
                                    </td>
                                    <td>{{ element.beneficiarioNombre }}</td>
                                    <td>{{ element.beneficiarioParentezco }}</td>
                                    <td>
                                        <span class="ds-chip" [ngClass]="getEstadoChipClase(element.progreso)">
                                            {{ element.progreso | estadosPipe }}
                                        </span>
                                    </td>
                                    <td class="mis-solicitudes__acc">
                                        <button type="button" class="ds-pill ds-pill--primary ds-pill--sm"
                                            (click)="verSolicitud(element)">
                                            <span class="material-icons">folder_open</span>
                                            Ver
                                        </button>
                                        <button type="button" class="ds-pill ds-pill--outline ds-pill--sm"
                                            [disabled]="!element.file.length"
                                            title="Ver autorización"
                                            (click)="openDialogPdf(usuario._id, element.file[0], usuario.fullName)">
                                            <span class="material-icons">visibility</span>
                                        </button>
                                        <button type="button" class="ds-pill ds-pill--outline ds-pill--sm"
                                            [disabled]="!element.file.length"
                                            title="Descargar autorización"
                                            (click)="download(usuario._id, element.file[0], usuario.fullName)">
                                            <span class="material-icons">download</span>
                                        </button>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>

                <!-- ============ Cards (mobile) ============ -->
                <div class="mis-solicitudes__cards">
                    <div class="ds-card mis-solicitudes__card-item"
                        *ngFor="let element of elementosPagina; trackBy: trackByElemento">
                        <div class="mis-solicitudes__card-head">
                            <span class="mis-solicitudes__card-tramite">{{ element.tramite }}</span>
                            <span class="ds-chip" [ngClass]="getEstadoChipClase(element.progreso)">
                                {{ element.progreso | estadosPipe }}
                            </span>
                        </div>

                        <div class="mis-solicitudes__card-row">
                            <span>Nro.</span><strong>{{ element._nro }}</strong>
                        </div>
                        <div class="mis-solicitudes__card-row">
                            <span>Fecha</span>
                            <strong>{{ element.fecha | date: "dd/MM/yy" }}</strong>
                        </div>
                        <div class="mis-solicitudes__card-row">
                            <span>Beneficiario</span><strong>{{ element.beneficiarioNombre }}</strong>
                        </div>
                        <div class="mis-solicitudes__card-row">
                            <span>Parentesco</span><strong>{{ element.beneficiarioParentezco }}</strong>
                        </div>

                        <div class="mis-solicitudes__card-acc">
                            <button type="button" class="ds-pill ds-pill--primary ds-pill--sm"
                                (click)="verSolicitud(element)">
                                <span class="material-icons">folder_open</span>
                                Ver / cargar documentación
                            </button>
                            <button type="button" class="ds-pill ds-pill--outline ds-pill--sm"
                                [disabled]="!element.file.length"
                                title="Ver autorización"
                                (click)="openDialogPdf(usuario._id, element.file[0], usuario.fullName)">
                                <span class="material-icons">visibility</span>
                            </button>
                            <button type="button" class="ds-pill ds-pill--outline ds-pill--sm"
                                [disabled]="!element.file.length"
                                title="Descargar autorización"
                                (click)="download(usuario._id, element.file[0], usuario.fullName)">
                                <span class="material-icons">download</span>
                            </button>
                        </div>
                    </div>
                </div>

                <!-- ============ Paginación ============ -->
                <footer class="mis-solicitudes__pag">
                    <div class="mis-solicitudes__pag-size">
                        <select [value]="pageSize" (change)="onPageSizeChange($event)"
                            aria-label="Resultados por página">
                            <option *ngFor="let size of pageSizeOptions" [value]="size">{{ size }}</option>
                        </select>
                        <span>por página</span>
                    </div>

                    <span class="mis-solicitudes__pag-info">
                        {{ elementosFiltrados.length }} resultados
                    </span>

                    <div class="mis-solicitudes__pag-nav">
                        <button type="button" class="mis-solicitudes__pag-btn"
                            (click)="cambiarPagina(paginaActual - 1)"
                            [disabled]="paginaActual <= 1" aria-label="Anterior">‹</button>
                        <span class="mis-solicitudes__pag-actual">
                            {{ paginaActual }} / {{ totalPaginas }}
                        </span>
                        <button type="button" class="mis-solicitudes__pag-btn"
                            (click)="cambiarPagina(paginaActual + 1)"
                            [disabled]="paginaActual >= totalPaginas" aria-label="Siguiente">›</button>
                    </div>
                </footer>
            </ng-container>
        </ng-container>
    </div>
</div>
